module.exports = __webpack_public_path__ + "img/activities-4.142d2d6b.jpg";